import React, { memo, useEffect } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import TeamMatchupImage from '@mlb/react-patterns/v4/components/TeamMatchupImage/teamMatchupImage';
import useTracking from '@gameday/utils/hooks/useTracking';

const fallbackCfg = {
    componentName: ['Tap Story Fallback'],
    activity: 'Fallback',
    linkName: 'Tap Story Fallback'
};

const FallbackImage = ({
    awayTeamId,
    homeTeamId,
    srcSetWidth,
    srcWidth
}) => {
    const Tracking = useTracking();

    useEffect(() => {
        Tracking.track.track_click(fallbackCfg);
    }, []);

    return (
        <TeamMatchupImage
            awayTeamId={awayTeamId}
            homeTeamId={homeTeamId}
            ratio="16:9"
            srcsetWidth={srcSetWidth}
            srcWidth={srcWidth}
        />
    );
};

FallbackImage.propTypes = {
    awayTeamId: PropTypes.number,
    homeTeamId: PropTypes.number,
    srcSetWidth: PropTypes.object,
    srcWidth: PropTypes.number
};

export default withTheme(memo(FallbackImage));
